import { useEffect, useState } from 'react';
import template from 'msp-scoring/template.json';
import { Category } from 'landing-page/views/filter-bar/filterConstants';

import { Template } from '@client:common/Template';
import { Model } from '@client:common/Model';
import { ModelComparisonTable } from '@client:common/model-comparison-table';
import { Tool } from '@client:common/Tool';

import './ModelComparator.light.scss';
import './ModelComparator.dark.scss';

interface Props {
  models: Model[];
  rowSpecifications: Array<{ path: string }>;
  tools: { [toolName: string]: Tool };
  template: Template;
}

export function ModelComparator(props: Props) {
  const [currentCategory, setCurrentCategory] = useState<string>();

  const filterCategories = (category: any) => {
    const tempCategory: any[] = [];
    category?.forEach((item: any) => {
      if (props.models.some((model: Model) => model.category === item.value)) {
        tempCategory.push(item);
      }
    });
    return tempCategory;
  };
  const categories: any[] = filterCategories(Category.filters);

  const params = new URLSearchParams(document.location.search);
  const selectedCategoryName = params.get('category');

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'initial';
    };
  }, []);

  useEffect(() => {
    if (!currentCategory && selectedCategoryName) {
      setCurrentCategory(selectedCategoryName);
    } else if (!currentCategory) {
      setCurrentCategory(categories[0]?.value);
    }
  }, [props, currentCategory, selectedCategoryName, categories]);

  if (props.tools === null || template === null) {
    return null;
  }

  const titleCase = (str: string) => {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  };

  return (
    <div className='model-comparator'>
      <header className='model-comparison-table__header'>
        <h2>Model Comparison Tables</h2>
      </header>
      <div className='model-comparator_category-selector-tab'>
        {categories?.map((item: any) => (
          <p
            key={item.id}
            className={`model-comparator_category-selector ${currentCategory === item.value ? 'active' : ''}`}
            onClick={() => setCurrentCategory(item.value)}
          >
            {titleCase(item.value)}
          </p>
        ))}
      </div>
      <ModelComparisonTable
        models={props.models.filter((item: Model) => item.category === currentCategory)}
        selectedModels={props.models.filter((item: Model) => item.category === currentCategory)}
        rowSpecifications={props.rowSpecifications[currentCategory as any] as any}
        template={template as unknown as Template}
        tools={props.tools}
      />
    </div>
  );
}
